import { useFeatureValue } from '@growthbook/growthbook-react';
import React from 'react';
import { useLocale } from './contexts/LocaleContext';
import { typedWindow } from './lib/Window';

export function ChatEmbed() {
  const { country, language } = useLocale();
  const decagonChatEnabled = useFeatureValue('decagon-chat-widget', false);

  // If experiment is enabled for session, use Decagon chat, otherwise use Ada chat
  if (decagonChatEnabled) {
    if (document.getElementById('chat-loader')) return <></>;
    /**
     * Decagon pins a full-viewport fixed iframe (pointer-events: none) that
     * only draws the chat bubble in its corner. iOS Safari routes pan
     * gestures to cross-origin iframes without honoring pointer-events, so
     * the invisible overlay silently swallows horizontal swipes page-wide
     * (carousels/scrollers stop panning; vertical scroll and taps survive).
     * While the chat is CLOSED (inline pointer-events: none) we shrink the
     * iframe to the bubble's corner; when Decagon opens it flips the inline
     * style to pointer-events: auto, the selector stops matching, and their
     * own full-size inline geometry applies again.
     */
    const panFix = document.createElement('style');
    panFix.id = 'decagon-pan-fix';
    panFix.textContent = [
      'iframe[src*="decagon.ai"][style*="pointer-events: none"] {',
      '  width: 120px !important;',
      '  height: 120px !important;',
      '}',
    ].join('\n');
    document.head.appendChild(panFix);
    const chatWidgetScript = document.createElement('script');
    chatWidgetScript.id = 'chat-loader';
    chatWidgetScript.src = 'https://decagon.ai/loaders/fi.js';
    chatWidgetScript.onload = () => {
      // Add user metadata containing the user's region for Decagon chat
      if (country && typedWindow.duet) {
        typedWindow.duet.setMetadata({
          userRegion: country,
          locale: language,
        });
      }
    };
    document.body.appendChild(chatWidgetScript);
  } else {
    if (document.getElementById('__ada')) return <></>;
    const adaScript = document.createElement('script');
    adaScript.src = 'https://static.ada.support/embed2.js';
    adaScript.dataset.handle = 'fi';
    adaScript.id = '__ada';
    document.body.appendChild(adaScript);
  }

  return <></>;
}
